<!--
Scales by the current screen's pixel ratio. Can be overwritten,
use `:pixel-ratio="1"` to keep the pixels as specified.

Slot `fallback` is rendered until the image loads successfully (or on error).
-->

<template>
  <div class="api-image-wrapper">
    <ion-img :src="src" @ionImgDidLoad="onLoad" @ionError="onError" />
    <div v-if="!loaded" class="api-image-fallback">
      <slot name="fallback">
        <ApiIcon :icon="hourglassOutline" />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IonImg } from '@ionic/vue';
import { ref, watch } from 'vue';
import { hourglassOutline } from 'ionicons/icons';
import { useImageUrl } from '@/composables/useImageUrl';
import ApiIcon from '@/components/ApiIcon.vue';

const props = defineProps<{
  uuid: string;
  size?: [number, number],
  pixelRation?: number,
}>();

const src = useImageUrl(() => props.uuid, () => props.size, () => props.pixelRation);

const loaded = ref(false);

watch(src, () => {
  loaded.value = false;
});

function onLoad() {
  loaded.value = true;
}

function onError() {
  // keep fallback visible on error
  loaded.value = false;
}
</script>

<style scoped>
.api-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.api-image-wrapper ion-img {
  display: block;
  width: 100%;
  height: 100%;
}

.api-image-fallback {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
